import React, { Component } from "react";
import { App } from "../../../App";
import { AppScreen } from "../../../AppScreen";
import { CharacterItemSlider } from "./CharacterItemSlider";
import landingSun from "../../../assets/images/sun.png";
import mrAdventure from "../../../assets/images/characters/mr-adventure.png";
import missExplorer from "../../../assets/images/characters/little-miss-explorer.png";
import { CloseButton } from "../../components/CloseButton";
import CharacterSvg from "../../components/characters/Character";
import CharacterLMESvg from "../../components/characters/CharacterLME";
import { Character, CharacterItemSelector } from "../../components/characters/CharacterItemSelector";
import { CharacterItem, CharacterItemId } from "../../components/characters/CharacterItem";
import { SunAnimation } from "../../components/animations/SunAnimation";
import { PlaneAnimation } from "../../components/animations/PlaneAnimation";
import { BeeAnimation } from "../../components/animations/BeeAnimation";

export interface CharacterSelectProps
{
    characterItemSelector: CharacterItemSelector;
    onCharacterPicked: (character: Character) => void;
    defaultScreen?: CharacterSelectScreen;
    defaultCharacter?: Character;
}

interface CharacterSelectState 
{
    screen: CharacterSelectScreen;
    characterItemClassName: string;
    activeItems: Array<CharacterItem>;
    character: Character;
}

export enum CharacterSelectScreen 
{
    PickCharacter,
    DressCharacter
}

export class CharacterSelect extends Component<CharacterSelectProps, CharacterSelectState>
{
    constructor(props: CharacterSelectProps)
    {
        super(props);

        this.state = {
            character: this.props.defaultCharacter ?? null,
            screen: this.props.defaultScreen ?? CharacterSelectScreen.PickCharacter,
            characterItemClassName: null,
            activeItems: this.props.characterItemSelector.activeItems
        };
    }

    public componentDidMount(): void
    {
        if (this.state.screen === CharacterSelectScreen.DressCharacter)
        {
            document.body.classList.add("dress-character");
        }

        // Create character item selector
        this.setState({
            characterItemClassName: this.props.characterItemSelector.className
        });
    }

    public componentWillUnmount(): void
    {
        document.body.classList.remove("dress-character");
    }

    private onCharacterPicked(character: Character): void 
    {
        document.body.classList.add("dress-character");

        let baseHand = this.props.characterItemSelector.allItems.filter(item => item.id === CharacterItemId.BaseHand)[0];
        let hat = this.props.characterItemSelector.allItems.filter(item => item.id === CharacterItemId.BlueHat)[0];
        if (character === Character.LMExpolorer)
        {
            hat = this.props.characterItemSelector.allItems.filter(item => item.id === CharacterItemId.BrownHat)[0];
        }
        this.props.characterItemSelector.selectItem(hat);
        this.props.characterItemSelector.selectItem(baseHand);

        this.setState({
            screen: CharacterSelectScreen.DressCharacter,
            character: character,
            characterItemClassName: this.props.characterItemSelector.className,
            activeItems: this.props.characterItemSelector.activeItems
        });
    }

    private onItemSelected(item: CharacterItem): void 
    {
        if (this.props.characterItemSelector.activeItems.indexOf(item) > -1)
        {
            this.props.characterItemSelector.deselectItem(item, this.props.defaultCharacter ?? this.state.character);
        }
        else 
        {
            this.props.characterItemSelector.selectItem(item);
        }

        this.setState({
            characterItemClassName: this.props.characterItemSelector.className,
            activeItems: this.props.characterItemSelector.activeItems
        });
    }

    private onReadyForPhotoClicked(): void 
    {
        document.body.classList.remove("dress-character");

        this.props.onCharacterPicked(this.state.character);
    }

    private onCloseClicked(): void 
    {
        document.body.classList.remove("dress-character");

        if (this.state.screen === CharacterSelectScreen.DressCharacter)
        {
            this.props.characterItemSelector.resetActiveItems();
            this.setState({
                screen: CharacterSelectScreen.PickCharacter
            });
        }
        else 
        {
            App.I.changeScreen(AppScreen.Landing);
        }
    }


    public render(): JSX.Element
    {
        return (
            <>
                <CloseButton onClicked={this.onCloseClicked.bind(this)} />
                <div className={"character-select-screen" + (this.state.screen === CharacterSelectScreen.DressCharacter ? " hide-bg" : "")}>

                    <div className="sun">
                        {/* <SunAnimation /> */}
                    </div>

                    <div className="container">
                        {
                            (() =>
                            {
                                switch (this.state.screen)
                                {
                                    case CharacterSelectScreen.PickCharacter:
                                        return (
                                            <div className="character-container">

                                                <h1 className="lead-title text-uppercase text-center">
                                                    Meet the characters
                                                </h1>

                                                <div className="text-center">
                                                    <p className="lead">
                                                        Have your photo taken with Mr.{" "}Adventure and Little Miss Explorer!
                                                    </p>

                                                    <p className="sub-title">
                                                        Who would you like to pose with?
                                                    </p>
                                                </div>

                                                <div className="d-flex btn-container">
                                                    <button className="btn btn-quiz" onClick={this.onCharacterPicked.bind(this, Character.MrAdventure)} title="Pose with Mr.Adventure">
                                                        <img src={mrAdventure} alt="Mr Adventure character" />
                                                    </button>

                                                    <button className="btn btn-quiz" onClick={this.onCharacterPicked.bind(this, Character.LMExpolorer)} title="Pose with Little Miss Explorer">
                                                        <img src={missExplorer} alt="Little Miss Explorer" />
                                                    </button>
                                                </div>

                                                <div className="p-3 text-center mt-auto">
                                                    <button className="btn btn-link" onClick={() => App.I.changeScreen(AppScreen.Landing)}>
                                                        Back to home
                                                        <i className="bi bi-chevron-right ps-1"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        );

                                    case CharacterSelectScreen.DressCharacter:
                                        return (
                                            <div className="dress-character">
                                                <div className="selected-character">
                                                    <div style={{ maxWidth: "100%", maxHeight: "100%" }} className={this.state.characterItemClassName + " m-auto"} id="characterContainer">
                                                        {this.state.character === Character.LMExpolorer
                                                            ?
                                                            <CharacterLMESvg />
                                                            :
                                                            <CharacterSvg />
                                                        }
                                                    </div>
                                                </div>
                                                <div className="mt-auto">
                                                    <p className="sub-title mt-2 mb-2 text-center">
                                                        Tap the items below to dress up {this.state.character === Character.MrAdventure ?
                                                            "Mr. Adventure" :
                                                            "Little Miss Explorer"
                                                        }
                                                    </p>

                                                    <CharacterItemSlider
                                                        onItemSelected={this.onItemSelected.bind(this)}
                                                        items={this.props.characterItemSelector.allItems.filter(item => item.hidden === false)}
                                                        activeItems={this.state.activeItems}
                                                    />

                                                    <div className="mt-3 ms-auto me-auto pt-0 pb-2 text-center">
                                                        <button className="btn btn-primary btn-lg"
                                                            onClick={this.onReadyForPhotoClicked.bind(this)}
                                                            title="Ready for a photo?">
                                                            Ready for a photo?
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                }
                            })()
                        }
                    </div>


                    <div className="animation-bee">
                        {/* <BeeAnimation /> */}
                    </div>
                </div>
            </>
        );
    }
}